import * as getter from '../types/getters'
import * as action from '../types/actions'
import linq from 'linq'
import Category from '../../models/Category'
import Form from 'vform'
import * as arrayUtility from '../../utility/arrayUtitlity'

const childrenPush = function (categories, category) {
    if (!category.parentId) {
        categories.push(category)
        return
    }
    linq.from(categories)
        .select((x) => {
            if (x.id === category.parentId) {
                x.children.push(category)
                return x
            }

            childrenPush(x.children, category)
        })
        .toArray()
}

const updateCategory = function (categories, category) {
    if (!category.parentId) {
        update(categories, category)
        return
    }
    linq.from(categories)
        .select((x) => {
            if (x.id === category.parentId) {
                update(x.children, category)
                return x
            }

            updateCategory(x.children, category)
        })
        .toArray()
}

const update = function (categories, category) {
    linq.from(categories)
        .where((x) => x.id === category.id)
        .select((x) => {
            x.name = category.name
            x.root = false
            return x
        })
        .orderBy((x) => x.id)
        .orderByDescending((x) => x.Lft)
        .toArray()
}

const deleteCategory = function (categories, category) {
    linq.from(categories)
        .select((x, i) => {
            return { key: i, value: x }
        })
        .where((x) => category)
        .where((x) => x.value.id === category.id)
        .select((x) => {
            categories.splice(x.key, 1)
            category = null
        })
        .toArray()

    if (category) {
        linq.from(categories)
            .select((x) => deleteCategory(x.children, category))
            .toArray()
    }
}

/**
 * root決定とlastを決定する
 * @param categories
 */
const decisionRoot = function (categories) {
    const src = linq.from(categories).doAction((x) => {
        if (x.children.length) {
            decisionRoot(x.children)
        }
    })

    src
        .doAction((x) => (x.root = false))
        .aggregate((prev, current) => {
            if (prev.Lft > current.Lft) {
                return current
            }
            return prev
        }).root = true

    src
        .doAction((x) => (x.last = false))
        .aggregate((prev, current) => {
            if (prev.Lft < current.Lft) {
                return current
            }
            return prev
        }).last = true
}

export const state = {
    categories: [],
    rightForm: new Form(),
    leftForm: new Form(),
}

export const mutations = {
    async [action.FETCH_CATEGORIES](state, categories) {
        state.categories = []
        await this._vm.$nextTick()
        decisionRoot(categories)
        state.categories = categories
    },

    async [action.ADD_CATEGORIES](state, category) {
        const c = state.categories.slice()
        state.categories = []
        await this._vm.$nextTick()
        childrenPush(c, category)
        decisionRoot(c)
        state.categories = c
    },

    async [action.UPDATE_CATEGORY](state, category) {
        updateCategory(state.categories, category)
        decisionRoot(state.categories)
    },

    async [action.DELETE_CATEGORY](state, category) {
        const c = state.categories.slice()
        state.categories = []
        await this._vm.$nextTick()
        deleteCategory(c, category)
        decisionRoot(c)
        state.categories = c
    },

    [action.CLEAR_CATEGORY](state) {
        state.categories = []
    },
}

export const actions = {
    async [action.FETCH_CATEGORIES]({ commit }) {
        const { data } = await axios.get('/api/categories')

        const d = linq
            .from(data)
            .select((x) => new Category(x))
            .toArray()
        commit(action.FETCH_CATEGORIES, d)
    },

    async [action.ADD_CATEGORIES]({ commit, state }, category) {
        state.leftForm = new Form(category.getPostable())
        const { data } = await state.leftForm.post('/api/category')

        commit(action.ADD_CATEGORIES, new Category(data))
    },

    async [action.UPDATE_CATEGORY]({ commit, state }, category) {
        state.rightForm = new Form(category.getPostable())
        await state.rightForm.patch('/api/category')

        commit(action.UPDATE_CATEGORY, category)
    },

    async [action.MOVE_CATEGORY]({ commit, state }, { category: category, up: up }) {
        state.rightForm = new Form(category.getPostable())

        let data
        if (up) {
            data = await state.rightForm.patch(`/api/category/up/${category.id}`)
        } else {
            data = await state.rightForm.patch(`/api/category/down/${category.id}`)
        }

        const d = linq
            .from(data.data)
            .select((x) => new Category(x))
            .toArray()
        arrayUtility.searchKeyMergeRecursive(d, state.categories, 'opened')
        commit(action.FETCH_CATEGORIES, d)
    },

    async [action.DELETE_CATEGORY]({ commit, state }, category) {
        state.rightForm = new Form(category.getPostable())
        await state.rightForm.delete('/api/category')
        commit(action.DELETE_CATEGORY, category)
    },

    async [action.ADD_CHILD_CATEGORY]({ commit, state }, { parentId: parentId, childId: childId }) {
        const { data } = await state.rightForm.patch(
            `/api/category/parent/${parentId}/child/${childId}`
        )
        const d = linq
            .from(data)
            .select((x) => new Category(x))
            .toArray()
        arrayUtility.searchKeyMergeRecursive(d, state.categories, 'opened')
        commit(action.FETCH_CATEGORIES, d)
    },

    async [action.HIERARCHY_UP_CATEGORY]({ commit, state }, category) {
        state.rightForm = new Form(category.getPostable())
        const { data } = await state.rightForm.patch('/api/category/hierarchyUp')

        const d = linq
            .from(data)
            .select((x) => new Category(x))
            .toArray()
        arrayUtility.searchKeyMergeRecursive(d, state.categories, 'opened')
        commit(action.FETCH_CATEGORIES, d)
    },

    [action.CLEAR_CATEGORY]({ commit }) {
        commit(action.CLEAR_CATEGORY)
    },
}

export const getters = {
    [getter.CATEGORIES]: (state) => state.categories,
    [getter.CATEGORY_RIGHT_FORM]: (state) => state.rightForm,
    [getter.CATEGORY_LEFT_FORM]: (state) => state.leftForm,
}

export default {
    state,
    mutations,
    actions,
    getters,
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/categories.js